<template>
	<div class="innerBox" >
  
		<h2>Salvage Part Details</h2>
		<div class="row mt-2" >
			<div class="col-sm-6 col-md-3">
				<button class=" btn btn-primary" @click="$router.push({name : 'SalvageParts'})"> < Back</button>
			</div>
			<div class="col-sm-6 offset-md-7 col-md-2">
				<button class="w-100 btn btn-info" @click="printTandaTerima()">Print Tanda Terima</button>
			</div>
		</div>

		<div class="outerBox" style="margin: 20px 0">
			<div class="innerBox">
				<div class="row">
					<div class="col-6">
						<h4>Nomor Work Order</h4>
						<p>{{form_code}}</p>
					</div>
					<div class="col-6">
						<h4>Insurance Company</h4>
						<p>{{insurance_company}}</p>
					</div>
				</div>
			</div>
		</div>

		<vue-universal-table
			:api_url="table.api_url"
			:buttons="table.buttons"
			:update="table.update"
			:special_buttons="['AddSalvage']"
			@onAddSalvage="modal.create = true"
			:disable_sort="true"
			:workOrderCode="form_code"
			:indexing="true"
			:fields="table.fields"
		></vue-universal-table>

		

			<edit-salvage-parts
				v-if="modal.edit"
				:editObj = "editObj"
				@closeModal="modal.edit = false"
				@updateTable="table.update++"
			></edit-salvage-parts>

			<new-salvage-parts
				v-if="modal.create"
				:prop_options="options"
				:workOrderCode="form_code"
				@closeModal="modal.create = false"
				@updateTable="vue_universal_table.update++"
			></new-salvage-parts>

		  <printSalvage 
		  	v-if="modal.print"
			  @closeModal="modal.print = false"
		  />
	</div>
</template>

<script>
import printSalvage from './children/printSalvage'
import editSalvageParts from './children/editSalvageParts'
    import newSalvageParts from './children/newSalvageParts'
export default {
	components : {
		editSalvageParts,
		printSalvage,
		newSalvageParts
	},
	data () {
		return {
			
			editObj : null,
			modal : {
				edit : false,
				print : false,
				create : false
			},
			options : {},
			estimationData : null,
			form_code : this.$route.params.form_code,
			insurance_company : this.$route.params.insurance_company,
			table : {
				api_url : '/api/v1/salvage-part/' + this.$route.params.form_code,
				update : 0,
				buttons : [
				// 	{
                //     title : 'Edit',
				// 	condition : 'data.id',
                //     class : 'btn-outline-primary fas fa-edit'
				// }, 
				{
                    title : 'Delete',
					variable : 'id',
					condition : 'data.id',
                    class : 'btn-outline-danger fas fa-times'
				}],
				fields : [{
					title : 'Sparepart Name',
					variable : 'sparepart_name'
				}, {
					title : 'Description',
					variable : 'description'
				},{
					title : 'Amount',
					variable : 'amount',
					number_formatting : true
				}, {
					title : 'Salvaged',
					variable : 'Salvaged',
					'style_condition' : {
						'Y' : 'color : #2E8B57;font-weight:bold',
						'N' : 'color : red;font-weight:bold'
					}
				}, {
					title : 'Salvage Date',
					variable : 'salvage_date'
				}]
			}
		}
	},
	mounted () {
		this.getWoEstimation()
		this.fetchFilters()
	},
	methods : {
		printTandaTerima() {
			this.modal.print = true
		},
		getWoEstimation() {
			this.$http.get('/api/v1/workorder-estimation/' + this.form_code)
			.then((resp)=> {
				this.estimationData = resp.data.data
				console.log(this.estimationData)
			})
			.catch((err) => {
				console.log(err)
			})
		},
		editSalvagePart(obj){
            this.editObj = JSON.parse(obj);
            this.modal.edit = true;
        },
        deleteSalvagePart(id){
            this.$swal.fire({
                title: 'Apakah anda yakin?',
                text: "Salvage part akan dihapus!",
                type: 'warning',
                showCancelButton: true
                }).then((result) => {
                if (result.value) {
                    this.$http.delete(`/api/v1/salvage-part/${id}`)
                    .then((resp)=>{
                        this.vue_universal_table.update++;
                        this.$swal.fire(
                            'Berhasil!',
                            'Salvage part telah berhasi dihapus',
                            'success'
                        )
                    })
                    .catch((err)=>{console.log(err)})
                }
            })
		},
		async fetchFilters(){
          this.options.workorder = await this.getWorkOrderCode();
          this.options.insurance = await this.getInsuranceCompany();
        }
	}
	
}
</script>

<style scoped>
	p {
		font-size: 15px;
	}
</style>